import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

interface SpendActionProps {
  spend?: string;
  prefix?: string;
  suffix?: string;
  className?: string;
}

const SpendAction: React.FC<SpendActionProps> = ({
  spend,
  prefix,
  suffix,
  className,
}) => {
  return (
    <Tooltip>
      <TooltipTrigger className="z-20">
        <div
          className={cn(
            "z-10 flex h-[28px] px-[9.8px] py-[5.6px] items-center gap-[4.2px] squircle-mask squircle-radius-[8px] bg-[linear-gradient(97deg,rgba(255,255,255,0.80)_27.6%,rgba(255,255,255,0.80)_100.45%)] shadow-[0_0.7px_1.4px_0_rgba(0,0,0,0.05)] backdrop-blur-[1.6px]",
            className,
          )}
        >
          <span className={cn("mt-[1px] text-[11px] font-medium text-black")}>
            {prefix}
            {spend}
            {suffix}
          </span>
        </div>
      </TooltipTrigger>
      <TooltipPrimitive.Portal>
        <TooltipContent side="bottom" sideOffset={10} align="start">
          <p>Spend</p>
        </TooltipContent>
      </TooltipPrimitive.Portal>
    </Tooltip>
  );
};

export default SpendAction;
